module.exports = __webpack_public_path__ + "img/success.82ecc2c4.svg";